import React, { Component } from 'react';
import Header from './Header/Header';
import classes from 'cssClasses';


class PublicPage extends Component{
	// constructor(props){
	// 	super(props)
	// }

	render(){
		const container = this.props.container ? this.props.container : 'container' ;
		return (
			<div>
				<Header />
				<div className={classes(`${container}`)}>
					{this.props.children}
				</div>
			</div>
			);
	}
}
export default PublicPage;


// WEBPACK FOOTER //
// ./src/components/Frontend/Layout/Layout.js